// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_ej-0";
export var actionModalContentContainer = "_ej-1";
export var createTagButton = "_ej-2";
export var footerContainer = "_ej-7";
export var fullWidthDivider = "_ej-3";
export var hasCreateTagButton = "_ej-4";
export var noCreateTagButton = "_ej-5";
export var tagsContainer = "_ej-6";
export var tagsModalContentContainer = "_ej-8";